import { useResponsiveProp } from "@shopify/restyle";
import React from "react";
import { ScrollView } from "react-native";

import { WhooshThemeColors } from "@whoosh/design-system/src/theme/restyle/theme";

import { Box, HStack, VStack } from "../../../../components/primitive";

export type AgendaLayoutProps = {
  agenda: React.JSX.Element;
  header: React.JSX.Element;
  sidebarContent: React.JSX.Element;
  shouldCenter?: boolean;
  offsetTop?: boolean;
  bgColor?: WhooshThemeColors;
};

export const AgendaLayout = ({
  header,
  agenda,
  sidebarContent,
  shouldCenter,
  offsetTop,
  bgColor = "surface-secondary",
}: AgendaLayoutProps) => {
  const shouldDisplayScrollView = useResponsiveProp({
    base: 0,
    agendaSplit: 1,
  });
  return (
    <Box flex={1} height="100%" bg={bgColor}>
      {/**
       * This Box exists purely to color the left portion of the screen white
       * when on larger screens
       */}
      <Box
        width="50%"
        position="absolute"
        left={0}
        top={0}
        bottom={0}
        backgroundColor="surface-primary"
      />
      <Box
        flex={1}
        maxWidth={shouldCenter ? 1240 : "auto"}
        width="100%"
        marginHorizontal={shouldCenter ? "auto" : 0}
        paddingHorizontal={{ base: 0 }}
      >
        <HStack
          flex={1}
          backgroundColor="surface-secondary"
          flexDirection={{ base: "column", agendaSplit: "row" }}
        >
          <VStack
            width={{ base: "auto", agendaSplit: 400 }}
            zIndex={100}
            backgroundColor={{
              base: "transparent",
              agendaSplit: "surface-primary",
            }}
          >
            {header}
            {shouldDisplayScrollView ? (
              <ScrollView
                style={{
                  height: "100%",
                  marginBottom: 24,
                  paddingTop: 24,
                  paddingHorizontal: 16,
                  display: "flex",
                }}
              >
                {sidebarContent}
              </ScrollView>
            ) : null}
          </VStack>
          <VStack
            height="100%"
            flex={1}
            backgroundColor="surface-secondary"
            style={{
              marginTop: offsetTop ? -20 : 0, // This is to offset that we do not go over the header on mobile
            }}
          >
            {agenda}
          </VStack>
        </HStack>
      </Box>
    </Box>
  );
};
